<template>
    <TooltipOld :bind-to="bindTo"
                :opened="hasErrors && opened"
                :trigger-on="triggerOn"
                class="error-message-tooltip error">
        <div v-for="(it, id) in errors" :key="id">
            {{ it.$message }}
        </div>

        <slot />
    </TooltipOld>
</template>

<script>
export default {
    name: 'ErrorMessageTooltip',
    props: {
        value: {
            type: Object,
            default: () => ({
                $errors: [],
            }),
        },
        bindTo: {
            type: String,
            required: true,
        },
        triggerOn: {
            type: String,
            default: 'focus',
        },
        opened: {
            type: Boolean,
            default: true,
        },
        filteredRules: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        errors() {
            if (!Array.isArray(this.value.$errors))
                return [];

            return this.value.$errors.filter(it => !this.filteredRules.includes(it.$validator));
        },
        hasErrors() {
            return Array.isArray(this.value.$errors)
                && this.errors.length > 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.error-message-tooltip {

}
</style>
